import NiceModal from '@ebay/nice-modal-react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Skeleton from 'components/global/Skeleton';
import Typography from 'components/global/Typography';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';
import { PLATFORM } from 'utils/constants';
import PATHS from 'utils/paths';

import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';

import ConnectionWaysModal from '../ConnetionWays/ConnectionWaysModal';
import { setSalesChannel } from '../salesChannelDetailsSlice';
import * as S from './OnlineStoreCard.styled';

const OnlineStoreCard = ({ store, skeleton = false }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const handleCardClick = () => {
		if (skeleton) return;
		const connectionWays = store?.connectionWays;

		if (import.meta.env.VITE_PLATFORM === PLATFORM.desktop && store?.integrationName === 'salla-automation') {
			dispatch(setSalesChannel(connectionWays.find((way) => way?.slug === 'salla-desktop')));
			navigate(`${PATHS.SALES_CHANNELS}/salla-desktop`);
			return;
		}

		if (connectionWays?.length > 0) {
			NiceModal.show(ConnectionWaysModal, {
				connectionWays
			});
		} else {
			dispatch(setSalesChannel(store));
			navigate(`${PATHS.SALES_CHANNELS}/${store?.slug}`);
		}
	};

	if (skeleton) {
		return <OnlineStoreCardSkeleton />;
	}

	return (
		<S.StoreCard onClick={isMobile ? handleCardClick : null}>
			<S.StyledImage url={store?.icon} width="4.8rem" height="4.8rem" />
			<S.Content>
				<Typography css={skeleton !== true && S.TitleCss} noWrap fontWeight="500" variant="p2">
					{t(`salesChannel.${store?.integrationName}`)}
				</Typography>
				<Typography variant="caption" maxlines={3} noWrap>
					{store?.description || 'defaultSalesChannelsDescription'}
				</Typography>
				<S.Actions>
					<Button variant="outline" size="small" onClick={handleCardClick} fullWidth label="exploreChannel" />
				</S.Actions>
			</S.Content>
			<S.MobileActions>
				<S.StyledIcon icon={faAngleRight} size="large" />
			</S.MobileActions>
		</S.StoreCard>
	);
};

OnlineStoreCard.propTypes = {
	store: PropTypes.object,
	skeleton: PropTypes.bool
};

const OnlineStoreCardSkeleton = () => (
	<S.StoreCard>
		<Skeleton width="4.8rem" height="4.8rem" borderRadius="var(--small-border-radius)" />
		<S.Content>
			<Skeleton width="100%" maxWidth="20rem" height="2rem" borderRadius="var(--small-border-radius)" />
			<Skeleton width="100%" height="3rem" borderRadius="var(--small-border-radius)" />
			<S.Actions>
				<Skeleton width="100%" height="3.2rem" borderRadius="var(--small-border-radius)" />
			</S.Actions>
		</S.Content>
		<S.MobileActions>
			<Skeleton width="2.4rem" height="2.4rem" borderRadius="var(--small-border-radius)" />
		</S.MobileActions>
	</S.StoreCard>
);

export default OnlineStoreCard;
